<template>
  <div class="academyLists clearfix">
    <div
      class="academyBox"
      v-for="(item, i) in list"
      :key="i"
      @click="gotoacademyDetail(item.id)"
    >
      <div class="imgBox">
        <img
          class="academyImg"
          :src="item.banner | imageUrl('', 510, 146)"
          alt=""
        />
        <span class="ad" v-if="item.type==2">{{ $t("video.广告") }}</span>
      </div>
      <div class="titleBox">
        <p class="title">
          {{ language === "zh" ? item.title : item.enTitle || item.title }}
        </p>
        <p class="content">
          {{
            language === "zh"
              ? item.introduction
              : item.enIntroduction || item.introduction
          }}
        </p>
        <p class="numbers">
          <span>{{$t('global.视频')}}</span><i>{{ item.videoCount }}</i
          ><span>{{$t('global.成员')}}</span><i>{{ item.memberCount }}</i>
        </p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "academyLists",
  data() {
    return {};
  },
  methods: {
    gotoacademyDetail(id) {
      let routeData = this.$router.resolve({
        path: "/subjectDetail/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
  },
  props: {
    list: Array,
  },
  created() {},
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.academyLists {
  width: 1110px;

  .academyBox {
    width: 255px;
    height: 210px;
    border: 1px solid #E0E0E0;
    float: left;
    margin-right: 30px;
    box-sizing: border-box;
    cursor: pointer;

    &:nth-child(4) {
      margin-right: 0;
    }

    .imgBox {
      position: relative;
      width: 253px;
      height: 73px;
      .academyImg {
        width: 100%;
        height: 100%;
      }

      .ad {
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 0 4px;
        height: 16px;
        text-align: center;
        background: rgba(51, 51, 51, 0.4);
        border-radius: 0px 6px 0px 0px;
        line-height: 16px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .titleBox {
      padding: 0 15px;

      .title {
        height: 21px;
        font-size: 14px;
        font-weight: 600;
        color: #0A0A0A;
        line-height: 21px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        margin: 16px 0 10px 0;
      }

      .content {
        min-height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
        margin-bottom: 16px;
      }

      .numbers {
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;

        i {
          margin: 0 20px 0 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/academyLists.vue